import * as http from './http';
import {
  ApiResponse,
  Customer,
  LeadDemographic,
  PaginatedApiResponse,
  ListSort,
  CivilIdDetails,
  ISalesPersonFilter,
  Phone,
} from '../models';
import ApiService from './service';
import { Dict } from '../../models';
import { GlobalSearchList, SearchHistory } from '../models/global-search';

export class GlobalSearchService extends ApiService {
  public async getGlobalSearch(
    query: string,
    category?: string
  ): Promise<GlobalSearchList[]> {
    const url = `${this.apiDomain}/api/global-search?query=${query}&category=${category}`;

    const response = await http.get<PaginatedApiResponse<GlobalSearchList>>(
      url,
      this.store
    );

    return response?.data?.data;
  }

  public async updateSearchHistory(
    globalId: string,
    keyWord: string,
    category: string
  ) {
    const url = `${this.apiDomain}/api/global-search/`;

    const response = await http.post<ApiResponse<string[]>>(
      url,
      { globalId, keyWord, category },
      this.store
    );

    return response?.data?.data;
  }

  public async updateSearchView(id: string, category: string) {
    const url = `${this.apiDomain}/api/global-search/`;

    const response = await http.put<ApiResponse<string[]>>(
      url,
      { id, category },
      this.store
    );

    return response?.data?.data;
  }

  public async getSearchHistory(): Promise<{
    searchHistory: SearchHistory[];
    searchList: GlobalSearchList[];
  }> {
    const url = `${this.apiDomain}/api/global-search/history`;

    const response = await http.get<
      ApiResponse<{
        searchHistory: SearchHistory[];
        searchList: GlobalSearchList[];
      }>
    >(url, this.store);

    return response?.data?.data;
  }
}
